import { Link, useLocation } from 'react-router-dom';
import { mainNavItems } from './config';

export default function MainNav() {
  const location = useLocation();

  return (
    <nav className="hidden md:flex items-center gap-6">
      {mainNavItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.href;
        
        return (
          <Link
            key={item.href}
            to={item.href}
            className={`flex items-center gap-2 text-sm font-medium transition-colors ${
              isActive
                ? 'text-purple-600'
                : 'text-gray-600 hover:text-purple-600'
            }`}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon size={16} />
            {item.title}
          </Link>
        );
      })}
    </nav>
  );
}